// extracted by mini-css-extract-plugin
export default {"League":"style_League__Gy2p7","LeagueClicked":"style_LeagueClicked__clbUi","rowFlash":"style_rowFlash__jCF-+","LeagueTdTh":"style_LeagueTdTh__IYY3t"};